import React, { useEffect, useState } from 'react';
import Slider from "react-slick";
import { useSearchParams } from 'react-router-dom';

export default function CarouselSlider({ channels, onChannelSelect }) {
    const [searchParams, setSearchParams] = useSearchParams();
    const [sliderReady, setSliderReady] = useState(false);
    const selectedIndex = parseInt(searchParams.get("channel"), 10);

    useEffect(() => {
        if (channels.length > 0) {
            // Delay re-render so Slick can recalculate properly
            setTimeout(() => setSliderReady(true), 100);
        }
    }, [channels]);

    const settings = {
        dots: false,
        infinite: false,
        arrows: false,
        speed: 500,
        slidesToShow: 7,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1024,
                settings: { slidesToShow: 6, slidesToScroll: 3 }
            },
            {
                breakpoint: 768,
                settings: { slidesToShow: 5, slidesToScroll: 2 }
            },
            {
                breakpoint: 480,
                settings: { slidesToShow: 4, slidesToScroll: 2 }
            }
        ]
    };

    const handleChannelClick = (channel, index) => {
        if (window.location.pathname !== "/") {
            window.location.href = "/?channel=" + index;
        } else {
            setSearchParams({ channel: index });
            onChannelSelect(index);
        }
    };

    return (
        <div className="slider-container">
            {sliderReady && (
                <Slider {...settings}>
                    {channels.map((channel, index) => {
                        const isActive = index === selectedIndex;
                        return (
                            <div
                                key={channel.id || index}
                                className={`d-flex flex-column align-items-center gap-2 ${isActive ? 'active-channel' : ''}`}
                                onClick={() => handleChannelClick(channel, index)}
                                style={{ cursor: 'pointer' }}
                            >
                                <img className="image_circle" src={channel.profileImage} alt="..." />
                                <p className='circle_category_title text-center'>{channel.name}</p>
                            </div>
                        );
                    })}
                </Slider>
            )}
        </div>
    );
}
